import React, { useState } from 'react'

export const UseForm = (params) => {
    const [Entidad, SetEntidad] = useState({})
    const OnChange = (values, ctrl) => {
        let { name, value } = ctrl
        if (Object.keys(ctrl).includes("checked")) { value = ctrl.checked; }

        SetEntidad((state) => {
            const _entity = { ...state }
            if (ctrl.options) {
                if (value) {
                    _entity[name] = { id: value }
                } else {
                    _entity[name] = null;
                }
            } else {
                if (name.includes(".")) {
                    let _subEntity = _entity[name.split(".")[0]];
                    _subEntity[name.split(".")[1]] = value
                    _entity[name.split(".")[0]] = _subEntity
                } else {
                    _entity[name] = value
                }
            }
            return { ..._entity }
        })
    }
    return {
        Entidad,
        SetEntidad,
        OnChange,
    }
}
